export default __webpack_public_path__ + "static/media/list_alt.1fb19437.svg";